export default __webpack_public_path__ + "static/media/settings.c0a59028.svg";